module.exports = __webpack_public_path__ + "static/media/toonification3.cbdd7ac3.gif";